import { AxiosError } from 'axios'

import { get } from '../../utils/api'
import { handleApiErrors } from '../../utils/apiErrors'
import { TrainingDownload } from './types'

const downloadTrainingFile = async (trainingId: number) => {
  get<TrainingDownload>(`/trainings/${trainingId}/download/`)
    .then((data) => {
      window.open(data.outputFile)
    })
    .catch((errors: AxiosError) => {
      handleApiErrors(errors)
    })
}

export { downloadTrainingFile }
